import React, { useState } from "react";
import { Button, Grid, makeStyles, CircularProgress } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import AuthWrapper from "../authWrapper";
import CustomTextField from "../../../common-components/CustomTextField";
import { useDispatch, useSelector } from "react-redux";
import { resetForgotPassword } from "../../../reducers/forgot-password-reducer";
import { changePasswordOtpAPI } from "../../../api/admin-api";
import ActionMessages from "../../../common-components/ActionMessages";

const useStyles = makeStyles((theme) => ({
  formWrapper: {
    margin: "0 28% 0 30%",
    width: "40%",
    height: "300px !important",
    position: "absolute !important",
    top: "20% !important",
  },
  welcomeWrapper: {
    padding: theme.spacing(4),
    background: "#ffffff",
    borderRadius: 8,
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
  },
  welcomeHead: {
    fontSize: 24,
    fontWeight: 600,
    marginBottom: theme.spacing(1),
    textAlign: "center",
  },
  fieldStyle: {
    width: "60%",
    margin: "8px auto",
  },
  loginNote: {
    fontSize: 16,
    marginBottom: theme.spacing(3),
    textAlign: "center",
  },
  loginBtn: {
    textTransform: "none",
    borderRadius: theme.spacing(3),
    background: "#0176D3 !important",
    fontWeight: 500,
    width: "60%",
    marginTop: theme.spacing(4),
    padding: "12px 0 !important",
  },
  dangerText: {
    color: "red",
  },
}));

function ChangePasswordForm() {
  const forgotPassDetails = useSelector((state) => state.forgotPasswordReducer);
  const dispatch = useDispatch();
  const classes = useStyles();
  const history = useHistory();

  // Checking if the email and accesstoken exist in the store
  if (!forgotPassDetails.email) history.push("/emailverify");

  if (!forgotPassDetails.accessToken) history.push("/otpvalidate");

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [loading, setLoading] = useState(false);

  const [msgType, setMsgType] = useState();
  const [msgText, setMsgText] = useState();
  const [isErrOpen, setIsErrOpen] = useState(false);

  const errToggler = () => setIsErrOpen((prev) => !prev);

  const isPasswordStrong = (pwd) => {
    const regex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#_\-])[A-Za-z\d@$!%*?&#_\-]{8,}$/;

    return regex.test(pwd);
  };

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);

    if (!value) {
      setPasswordError("Password is required");
    } else if (!isPasswordStrong(value)) {
      setPasswordError(
        "Password must be at least 8 characters long, include uppercase, digit, and special character"
      );
    } else {
      setPasswordError("");
    }

    if (confirmPassword && confirmPassword !== value) {
      setConfirmPasswordError("Passwords do not match");
    } else {
      setConfirmPasswordError("");
    }
  };

  const handleConfirmPasswordChange = (e) => {
    const value = e.target.value;
    setConfirmPassword(value);

    if (!value) {
      setConfirmPasswordError("Confirm Password is required");
    } else if (value !== password) {
      setConfirmPasswordError("Passwords do not match");
    } else {
      setConfirmPasswordError("");
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!password) setPasswordError("Password is required");
    if (!confirmPassword)
      setConfirmPasswordError("Confirm Password is required");

    if (
      passwordError ||
      confirmPasswordError ||
      !password ||
      !confirmPassword
    ) {
      return;
    }

    try {
      setLoading(true);

      await changePasswordOtpAPI({
        email: forgotPassDetails.email,
        password: password,
        accessToken: forgotPassDetails.accessToken,
      });

      setTimeout(() => {
        dispatch(resetForgotPassword());
      }, 10);

      setTimeout(() => {
        history.push("/login");
      }, 500);
    } catch (err) {
      console.error("Failed to change password:", err);
      setMsgType("error");
      setMsgText("Failed to change password. Please try again.");
      setIsErrOpen(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <AuthWrapper>
        <Grid item lg={12} className={classes.welcomeHead}>
          <span>Change Password</span>
        </Grid>
        <Grid item lg={12} className={classes.loginNote}>
          Set a new password
        </Grid>

        <Grid item lg={12}>
          <div className={classes.fieldStyle}>
            <CustomTextField
              selectedValue={password}
              onChangeItem={handlePasswordChange}
              labelVal="New Password"
              id="newPassword"
              type="password"
              errorValue={!!passwordError}
              isLoginField={true}
              helperText={
                passwordError && (
                  <span className={classes.dangerText}>{passwordError}</span>
                )
              }
            />
          </div>
        </Grid>

        <Grid item lg={12}>
          <div className={classes.fieldStyle}>
            <CustomTextField
              selectedValue={confirmPassword}
              onChangeItem={handleConfirmPasswordChange}
              labelVal="Confirm Password"
              id="confirmPassword"
              type="password"
              errorValue={!!confirmPasswordError}
              isLoginField={true}
              helperText={
                confirmPasswordError && (
                  <span className={classes.dangerText}>
                    {confirmPasswordError}
                  </span>
                )
              }
            />
          </div>
        </Grid>

        <Grid item lg={12}>
          <Button
            variant="contained"
            color="primary"
            disableElevation
            className={classes.loginBtn}
            type="button"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={24} style={{ color: "#fff" }} />
            ) : (
              "Update password"
            )}
          </Button>
        </Grid>
      </AuthWrapper>

      {isErrOpen && (
        <ActionMessages
          type={msgType}
          isClosed={errToggler}
          message={msgText}
        />
      )}
    </>
  );
}

export default ChangePasswordForm;
